import {Grid, Hero, Text, type HeadingProps} from '@primer/react-brand/esm'
import {useId} from 'react'

import type {SignUpField} from '../../../Index.types'
import {SignUpForm} from '../SignUpForm/SignUpForm'

import Styles from './CommunityFooter.module.css'

export interface CommunityFooterProps {
  label: string
  title: string
  description: string
  signUp: SignUpField
}

export const defaultProps: Partial<CommunityFooterProps> = {}

// Hero.Heading forwards these props but omits `as` from its public type.
const HEADING_PROPS = {as: 'h2', size: '4', textWrap: 'wrap'} satisfies HeadingProps

export const CommunityFooter = (props: CommunityFooterProps) => {
  const initializedProps: CommunityFooterProps = {...defaultProps, ...props}
  const {label, title, description, signUp} = initializedProps
  const titleId = useId()

  return (
    <section className={Styles['CommunityFooter']} aria-labelledby={titleId}>
      <Grid columnGap="none" rowGap="none" enableGutters={false}>
        <Grid.Column span={{xsmall: 12, large: 6}} className={Styles['CommunityFooter__header']}>
          <Hero className={Styles['CommunityFooter__hero']} aria-labelledby={undefined}>
            <Hero.Label animate className={Styles['CommunityFooter__label']}>
              {label}
            </Hero.Label>
            <Hero.Heading {...HEADING_PROPS} id={titleId} className={Styles['CommunityFooter__heading']}>
              {title}
            </Hero.Heading>
          </Hero>
        </Grid.Column>

        <Grid.Column span={{xsmall: 12, large: 6}} className={Styles['CommunityFooter__body']}>
          <Text as="p" size="300" variant="muted">
            {description}
          </Text>
          <SignUpForm
            className={Styles['CommunityFooter__signUpForm']}
            signUp={signUp}
            formLabel={title}
            location="footer"
          />
        </Grid.Column>
      </Grid>
    </section>
  )
}
